import {useLocalStorage} from "usehooks-ts";
import {useCallback} from "react";

export const useAccessToken = () => {
    const [access_token, setAccessToken] = useLocalStorage<string>('access_token','',{
        serializer: (x)=>x,
        deserializer: (x)=>x
    })
    const s = useCallback((str: string)=>{
        setAccessToken(str)
    },[setAccessToken])
    return {access_token, setAccessToken: s}
}